import { createRouter, createWebHashHistory } from "vue-router";

import coreRoutes from "@/core/routes.js";
import featureV2Routes from "@/features/routes.v2";

import PageNotFoundRedirect from "@/core/components/PageNotFoundRedirect.vue";
import { setupRouteGuards } from "@/router/guards.js";

function redirectIfNoSlash(to) {
  if (to.path !== "/" && !to.path.endsWith("/")) {
    return {
      path: `${to.path}/`,
      query: to.query,
      hash: to.hash,
      replace: true,
    };
  }

  return false;
}

function withDefaultMeta(route) {
  return {
    ...route,
    meta: {
      breadcrumbs: [{ name: "Home", route: "home" }],
      ...(route.meta || {}),
    },
  };
}

const routes = [
  ...coreRoutes,
  ...featureV2Routes,

  {
    path: "/:pathMatch(.*)*",
    name: "not-found-redirect",
    component: PageNotFoundRedirect,
    meta: {},
  },
].map(withDefaultMeta);

const router = createRouter({
  history: createWebHashHistory(""),
  routes,
});

router.beforeEach((to, from, next) => {
  const redirectTarget = redirectIfNoSlash(to);
  if (redirectTarget) return next(redirectTarget);
  return next();
});

setupRouteGuards(router);

export default router;